import { useState, useEffect } from 'react';
import { Briefcase, Car, Users, CarFront, Ticket } from 'lucide-react';
import dashboardService from '../services/dashboardService';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const data = await dashboardService.getStats();
      setStats(data);
      setError('');
    } catch (err: any) {
      console.error('Fetch stats error:', err);
      setError(err.response?.data?.error?.message || err.message || 'Failed to load dashboard statistics');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="loading">Loading dashboard...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-container">
        <div className="error-message">{error}</div>
        <button onClick={fetchStats} className="btn-retry">Retry</button>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <h1>Dashboard</h1>

      <div className="stats-grid">
        {/* Admins Stats */}
        <div className="stat-card">
          <div className="stat-header">
            <h2>Admins</h2>
            <span className="stat-icon"><Briefcase size={24} /></span>
          </div>
          <div className="stat-value">{(stats?.users?.admins?.active || 0) + (stats?.users?.admins?.pending || 0)}</div>
          <div className="stat-details">
            <div className="stat-detail">
              <span>Active:</span>
              <span>{stats?.users?.admins?.active || 0}</span>
            </div>
            <div className="stat-detail">
              <span>Pending:</span>
              <span>{stats?.users?.admins?.pending || 0}</span>
            </div>
          </div>
        </div>

        {/* Drivers Stats */}
        <div className="stat-card">
          <div className="stat-header">
            <h2>Drivers</h2>
            <span className="stat-icon"><Car size={24} /></span>
          </div>
          <div className="stat-value">{(stats?.users?.drivers?.active || 0) + (stats?.users?.drivers?.pending || 0)}</div>
          <div className="stat-details">
            <div className="stat-detail">
              <span>Active:</span>
              <span>{stats?.users?.drivers?.active || 0}</span>
            </div>
            <div className="stat-detail">
              <span>Pending:</span>
              <span>{stats?.users?.drivers?.pending || 0}</span>
            </div>
          </div>
        </div>

        {/* Passengers Stats */}
        <div className="stat-card">
          <div className="stat-header">
            <h2>Passengers</h2>
            <span className="stat-icon"><Users size={24} /></span>
          </div>
          <div className="stat-value">{(stats?.users?.passengers?.active || 0) + (stats?.users?.passengers?.pending || 0)}</div>
          <div className="stat-details">
            <div className="stat-detail">
              <span>Active:</span>
              <span>{stats?.users?.passengers?.active || 0}</span>
            </div>
            <div className="stat-detail">
              <span>Pending:</span>
              <span>{stats?.users?.passengers?.pending || 0}</span>
            </div>
          </div>
        </div>

        {/* Rides Stats */}
        <div className="stat-card">
          <div className="stat-header">
            <h2>Rides</h2>
            <span className="stat-icon"><CarFront size={24} /></span>
          </div>
          <div className="stat-value">{stats?.rides?.total || 0}</div>
          <div className="stat-details">
            <div className="stat-detail">
              <span>Active:</span>
              <span>{stats?.rides?.byStatus?.active || 0}</span>
            </div>
            <div className="stat-detail">
              <span>Completed:</span>
              <span>{stats?.rides?.byStatus?.completed || 0}</span>
            </div>
            <div className="stat-detail">
              <span>Cancelled:</span>
              <span>{stats?.rides?.byStatus?.cancelled || 0}</span>
            </div>
          </div>
        </div>

        {/* Bookings Stats */}
        <div className="stat-card">
          <div className="stat-header">
            <h2>Bookings</h2>
            <span className="stat-icon"><Ticket size={24} /></span>
          </div>
          <div className="stat-value">{stats?.bookings?.total || 0}</div>
          <div className="stat-details">
            <div className="stat-detail">
              <span>Confirmed:</span>
              <span>{stats?.bookings?.confirmed || 0}</span>
            </div>
            <div className="stat-detail">
              <span>Completed:</span>
              <span>{stats?.bookings?.completed || 0}</span>
            </div>
            <div className="stat-detail">
              <span>Cancelled:</span>
              <span>{stats?.bookings?.cancelled || 0}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
